module.exports = __webpack_public_path__ + "assets/img/dzdp-log.63410a6c.png";